import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { notificationsKeys } from "../api/queries";

const INVALIDATE_DEBOUNCE_MS = 300;

/** Refetch notification counts when Postgres NOTIFY reaches the Admin SSE stream. */
export function useAdminNotificationStream(enabled: boolean): void {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!enabled) return;

    const source = new EventSource("/api/notifications/stream");
    let timer: ReturnType<typeof setTimeout> | null = null;

    const scheduleInvalidate = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        void queryClient.invalidateQueries({
          queryKey: notificationsKeys.summary(),
        });
      }, INVALIDATE_DEBOUNCE_MS);
    };

    source.addEventListener("notifications.changed", scheduleInvalidate);
    source.addEventListener("connected", scheduleInvalidate);

    return () => {
      if (timer) clearTimeout(timer);
      source.close();
    };
  }, [enabled, queryClient]);
}
